import React, {useState} from 'react';
import * as Yup from 'yup';
import '../styles.scss';
import {connect} from 'react-redux';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {compose} from 'redux';
import {
  AppForm,
  AppFormField,
  AppFormSubmitButton,
} from '../../../../components/forms';
import {Row} from '../../../../components/layout';
import {strings} from '../../../../util/strings';
import * as fonts from '../../../../util/fonts';
import colors from '../../../../util/colors';
import NewErrorMessage from '../../../../components/new-error-message';
import {Icons} from '../../../../util/icons';

export interface SubmitNumberProps extends RouteComponentProps {
  formik: any;
  setFormikContext(formik: any): void;
  submitMobile(values: any): void;
  showForbiddenError: boolean;
  showGeneralError: boolean;
  labels: typeof strings.pt.login;
  labelsMessages: typeof strings.pt.messages;
}

const SubmitNumber = ({
  formik,
  setFormikContext,
  submitMobile,
  labels,
  labelsMessages,
  showForbiddenError,
  showGeneralError,
}: SubmitNumberProps) => {
  const validationSchema = Yup.object().shape({
    mobile: Yup.string()
      .required(labelsMessages?.requiredField)
      .matches(/^\+?[0-9\-()]{9,15}$/, labelsMessages?.invalidFormat),
  });

  const [validForm, setValidForm] = useState(false);

  return (
    <div>
      <AppForm
        className="communications-form-container"
        initialValues={{
          termsAccepted: false,
          privacyPolicyAccepted: false,
        }}
        validationSchema={validationSchema}
        onSubmit={async (values) => {
          submitMobile(values.mobile);
        }}>
        <div className="confirm-mobile-content">
          <div>
            <Row
              style={{...fonts.ML, ...fonts.SemiBold}}
              className="confirm-mobile-description">
              {labels?.login_confirmMobile_title}
            </Row>
            <Row
              style={{...fonts.M, ...fonts.SemiBold}}
              className="confirm-mobile-description-responsive">
              {labels?.login_confirmMobile_title}
            </Row>
            <Row
              style={{...fonts.M, ...fonts.Regular}}
              className="confirm-mobile-info">
              {labels?.login_confirmMobile_subTitle}
            </Row>
            <Row
              style={{...fonts.M, ...fonts.Regular}}
              className="confirm-mobile-info-responsive">
              {labels?.login_confirmMobile_subTitle}
            </Row>

            <div
              style={{
                textAlign: 'left',
                marginTop: 30,
                width: '60%',
                justifySelf: 'center',
              }}>
              <Row className="m-0 number-field-submit-number">
                {' '}
                <p
                  className={`mb-1 confirm-mobile-form-label`}
                  style={{
                    ...fonts.SM,
                    color: colors.black,
                  }}>
                  {labels?.login_confirmMobile_mobileLabelName}
                </p>
              </Row>
              <AppFormField
                showErrorMessage
                className="number-field"
                name="mobile"
                placeholder={labels?.login_confirmMobile_mobileLabelName}
                handleFormikContext={() => setFormikContext(formik)}
              />
              {showForbiddenError && (
                <NewErrorMessage
                  iconName={Icons.ALERT_PROBLEM}
                  colorIcon={colors.alertRed}
                  text={
                    labels?.login_confirmMobile_generalError
                  }></NewErrorMessage>
              )}
              {showGeneralError && (
                <NewErrorMessage
                  iconName={Icons.ALERT_PROBLEM}
                  colorIcon={colors.alertRed}
                  text={labelsMessages?.general_errorMessage}></NewErrorMessage>
              )}
            </div>
            <Row
              style={{...fonts.M, ...fonts.Regular}}
              className="confirm-mobile-submit-info">
              {labels?.login_confirmMobile_buttonTopText}
            </Row>
          </div>

          <div className="confirm-mobile-bottom">
            <Row
              style={{...fonts.M, ...fonts.Regular}}
              className="confirm-mobile-submit-info-responsive">
              {labels?.login_confirmMobile_buttonTopText}
            </Row>
          </div>
        </div>
        <Row className="continue-button-wrapper">
          <AppFormSubmitButton
            className="continue-button"
            variant="primary"
            type="submit"
            title={labels?.login_confirmMobile_buttonText}
          />
        </Row>
      </AppForm>
    </div>
  );
};

const mapStateToProps = ({strings, labelsMessages, globalStyles}: any) => ({
  labels: strings.value.pt.login,
  labelsMessages: strings.value.pt.messages,
  globalStyles: globalStyles.value,
});

export default compose(connect(mapStateToProps)(withRouter(SubmitNumber)));
